import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, Stack, Typography } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { AllUOMDetailsQuery } from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { CheckCircle, Error, Info } from "@mui/icons-material";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function UomListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [uomData, setUomData] = useState([]);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  console.log(isLoading,"isLoading");
  
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  useEffect(() => {
    fetchUomData();
    setStatus(false);
  }, [id, status]);

  //Table Mapping
  const uomListTable = {
    columns: [
      {
        label: "S.NO",
        field: "sno",
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "UOM ID",
        field: "uomid",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "UOM Name",
        field: "uomName",
        name: "UOM Name",
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "UOM Abbreviation",
        field: "uomAbbreviation",
        name: "UOM Abbreviation",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Decimal Places",
        field: "decimalPlaces",
        name: "Decimal Places",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Status",
        field: "status",
        name: "Status",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        type: "status",
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: uomData.reverse().map(
      (item, index) => (
        {
          id: item.id,
          sno: index + 1,
          uomid: item.uomid,
          uomName: item.uomName,
          uomAbbreviation: item.uomAbbreviation,
          decimalPlaces: item.decimalPlaces,
          baseUnit: item.baseUnit,
          baseUnitValue: item.baseUnitValue,
          createdBy: item.user.username,
          createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
          status: (
            <Box display="flex" alignItems="center" gap={1}>
              {item.status === true && <CheckCircle color="success" fontSize="small" />}
              {item.status === false && <Error color="error" fontSize="small" />}
              <Typography variant="body2">
                {item.status ? "Active" : "Inactive"}
              </Typography>
            </Box>
          ),
          
        }
      )
    ),
  };

  //API Integration
  const fetchUomData = () => {
    setIsLoading(true);
    request(BASEURL, AllUOMDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setUomData(res.allUom);
      })
      .finally(() => setIsLoading(false));
  };

  //Add Button
  const handleNewUom = () => {
    navigate("/uom/add-uom");
  };

  //Row Click
  const onUomListClick = (e) => {

    if (e?.id) {
      navigate(`/uom/add-uom?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={uomListTable.columns}
      rowsData={uomListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="UOM List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onUomListClick}
      // onDelete={onDelete}
      onView={onUomListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewUom()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  UOM List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewUom()}
              >
               Add UOM
              </MaterialButton>
            </Stack>
          }
        />
       {!isLoading && <MaterialDataGrid
          rows={uomListTable.rows}
          columns={uomListTable.columns}
          isSelectable={false}
          onRowClick={onUomListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Unit Of Measure found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Unit Of Measure details. Click on the
                  "Add UOM" button to start adding UOM details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />}
             {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
